import alertify from "alertifyjs/build/alertify.min.js";
import "alertifyjs/build/css/alertify.min.css";

export function alertifyMessage(type, message) {
	switch (type) {
		case "error":
			alertify.notify(message, "error", 5);
			break;
		case "success":
			alertify.notify(message, "success", 5);
			break;
		case "warning":
			alertify.notify(message, "warning", 5);
			break;
		case "info":
			alertify.notify(message);
			break;
		default:
			alertify.notify(message);
	}
}

// Scroll handler moved to Header component for better React integration and performance

// handleActiveClass() lived here. The header now derives its own active state from
// useLocation() instead of stamping .active onto the DOM after mount.

export const toggleNav = () => {
	document.body.classList.toggle("nav-slide-open");
};

document.addEventListener("click", function (e) {
	if (window.innerWidth < 992 && !e.target.closest("#slide-toggle")) {
		document.body.classList.remove("nav-slide-open");
	}
});

export const formatDate = (date) => {
	return (
		new Date(date).toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		})
	)
}

// Extract the video ID from a YouTube watch or share URL.
// Split out of iframeYoutubeURL so callers that need a thumbnail (rather than a
// player) can reuse the same parsing instead of duplicating it.
export const youtubeVideoId = (url) => {
	// url comes straight from the API and may be null/empty
	if (!url || typeof url !== "string") return "";

	try {
		// Short URL: youtu.be/VIDEO_ID
		if (url.includes("youtu.be")) {
			return url.split("/").pop().split("?")[0] || "";
		}

		// Long URL: youtube.com/watch?v=VIDEO_ID
		if (url.includes("watch?v=")) {
			return new URL(url).searchParams.get("v") || "";
		}
	} catch (error) {
		console.error("Could not parse YouTube URL", url, error);
		return "";
	}

	return "";
};

// Poster frame for a video, so a listing page can show every card without
// loading a YouTube player per card. hqdefault exists for every video;
// maxresdefault does not, and 404s on older uploads.
export const youtubeThumbnail = (url) => {
	const videoId = youtubeVideoId(url);
	return videoId ? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg` : "";
};

export const iframeYoutubeURL = (url) => {
	const videoId = youtubeVideoId(url);

	// Unrecognised format - return empty rather than embedding /embed/undefined
	if (!videoId) return "";

	return `https://www.youtube.com/embed/${videoId}`;
};